import axios from 'axios';
import type {
  IGetDocumentByDocumentIdParams,
  IGetDocumentByDocumentIdRequest,
  IGetDocumentByDocumentIdResponse,
} from '@/app-package';

const getDocumentByDocumentId = async (
  params: IGetDocumentByDocumentIdParams,
): Promise<IGetDocumentByDocumentIdResponse> => {
  const config: IGetDocumentByDocumentIdRequest = {
    url: `/supra/document/${params.documentId}`,
    method: 'get',
  };
  try {
    const { data } =
      await axios.request<IGetDocumentByDocumentIdResponse>(config);
    return data;
  } catch (error: any) {
    // Check for 404 error and return a nulled object
    if (error.response && error.response.status === 404) {
      return { documentEncodedString: null };
    }
    throw error;
  }
};

export default getDocumentByDocumentId;
